import { type FC } from 'react';
import cn from 'classnames';
import { Text, VStack } from '@direct-frontend/components';
import { type OrderProductProps } from '../../lib/types';
import styles from './OrderProductCharacteristics.module.css';

interface OrderProductCharacteristicsProps extends Pick<OrderProductProps, 'characteristics'> {
    className?: string;
}

export const OrderProductCharacteristics: FC<OrderProductCharacteristicsProps> = ({ characteristics, className }) => {
    if (!characteristics.length) {
        return null;
    }

    return (
        <VStack className={cn(styles.characteristics, className)} gap="6">
            {characteristics.map((characteristic, index) => (
                <div key={`${characteristic.value}-${index}`} className={styles.characteristic}>
                    <Text size="mc" role="supplementary" textAlign="left" maxLines={2} className={styles.text}>
                        {characteristic.title}:&nbsp;
                    </Text>

                    <Text size="mc" textAlign="left" maxLines={2} className={styles.text}>
                        {characteristic.value}
                    </Text>
                </div>
            ))}
        </VStack>
    );
};
